export const API_URL = process.env.REACT_APP_API_URL;
export const P24_URL = process.env.REACT_APP_P24_PAYMENT_URL;
export const GTM_ID = process.env.REACT_APP_GTM_ID;
